import React, { useEffect, useRef, useState } from 'react';
import FilterComponents from '../../../product/components/FilterComponents.tsx';
import CustomDataGrid from '../../../components/CustomDataGrid/CustomDataGrid.tsx';
import axios from 'axios';
import pencilIcon from './../../../../assets/icons/editPencil.png'
import filterIcon from './../../../../assets/icons/filter 1.png'
import bin from './../../../../assets/icons/recycle-binColor.png'
import { Box, Button, Grid, Modal, Typography, Paper, Tooltip } from '@mui/material'
import SweetAlertModal from '../../../components/SweetAlertModal/SweetAlertModal';
import { toast } from 'react-toastify';
import jwt_decode from "jwt-decode";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { Swiper, SwiperSlide } from "swiper/react";
import RightArrow from "../../../../assets/icons/right-arrow.png";
import LeftArrow from "../../../../assets/icons/left-arrow.png";
import AddLoyaltyDialog from '../AddLoyaltyDialog.tsx';
import UpdateLoyaltyDialog from './UpdateLoyality.tsx';
import { Settings } from '@mui/icons-material';
import LoyaltySettingsModal from './LoyaltySettingsModal.tsx';
import arrowUp from '../../../../assets/icons/arrowup.png';
import arrowDown from '../../../../assets/icons/arrowDown.png';

// Separate component for display order cell so hooks can be used safely
const DisplayOrderCell = ({
  params,
  lastRank,
  changeOrder,
  changeOrderByTextBox,
}: any) => {
  const isFirst = params.row.displayOrder === 1;
  const isLast = params.row.displayOrder === lastRank;

  const [inputValue, setInputValue] = useState(params.value);

  useEffect(() => {
    setInputValue(params.value);
  }, [params.value]);

  return (
    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
      <span
        style={{
          cursor: isFirst ? "not-allowed" : "pointer",
          opacity: isFirst ? 0.4 : 1,
        }}
        onClick={() => !isFirst && changeOrder(params.row, 2)}
      >
        <img src={arrowUp} style={{ width: "1rem" }} alt="up" />
      </span>

      <input
        type="number"
        className="form-control"
        style={{ width: "7rem" }}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            changeOrderByTextBox(event, params.row);
          }
        }}
      />

      <span
        style={{
          cursor: isLast ? "not-allowed" : "pointer",
          opacity: isLast ? 0.4 : 1,
        }}
        onClick={() => !isLast && changeOrder(params.row, 1)}
      >
        <img src={arrowDown} style={{ width: "1rem" }} alt="down" />
      </span>
    </div>
  );
};


function LoyaltyScheme(props: any) {
    const [restaurantDataRows, setRestaurantDataRows] = useState([])
    const [dataRows, setDataRows] = useState([])
    const [open, setOpen] = React.useState(false)
    const [selectedDatas, setselectedDatas] = useState()
    const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false)
    const [selectedDataRows, setSelectedDatarows] = React.useState([]);
    const [openAddSection, setOpenAddSection] = useState(false);
    const [dialogType, setDialogType] = useState('');
    const [selectedData, setSelectedData] = useState({})
    const [value, setValue] = React.useState<string>('0');
    const [activeTab, setActiveTab] = useState(0);
    const [selectedRes, setselectedRes] = useState();
    const [openSettingsModal, setOpenSettingsModal] = useState(false);
    const [lastRank, setLastRank] = useState(0);


    const sliderRef = useRef(null);
    const apiAddress = process.env.REACT_APP_SECRET;

    // Columns for Loyalty Scheme
    const columns = [

{
  field: "displayOrder",
  headerName: "Display Order",
  align: "center",
  headerAlign: "center",
  width: 200,
  renderCell: (params) => (
    <DisplayOrderCell
      params={params}
      lastRank={lastRank}
      changeOrder={changeOrder}
      changeOrderByTextBox={changeOrderByTextBox}
    />
  ),
},

        {
            field: 'orderAmount', 
            headerName: 'Order Amount', 
            align: 'center',
            headerAlign: 'center', 
            flex: 1
        },
        {
            field: 'reward', 
            headerName: 'Reward', 
            align: 'center',
            headerAlign: 'center', 
            flex: 1
        },
        {
            field: 'isEnabled', 
            headerName: 'Status', 
            align: 'center',
            headerAlign: 'center', 
            flex: 1,
            renderCell: (params) => (
                <span style={{ 
                    color: params.value ? 'green' : 'red',
                    fontWeight: 'bold'
                }}>
                    {params.value ? 'Enabled' : 'Disabled'}
                </span>
            )
        },
        {
            field: 'isCountIncreaseByOrder', 
            headerName: 'Count By Order', 
            align: 'center',
            headerAlign: 'center', 
            flex: 1,
            renderCell: (params) => (
                <span>{params.value ? 'Yes' : 'No'}</span>
            )
        },
        {
            field: 'actions', 
            headerName: 'Actions', 
            align: 'center',
            renderCell: (params) =>
                <div className='d-flex align-items-center justify-content-center' style={{ gap: "5px" }}>
                    <img 
                        src={pencilIcon} 
                        alt="edit" 
                        style={{ width: ".8rem", cursor: "pointer" }}
                        onClick={() => { selectDataForEdit(params.row); setOpen(true) }}
                    />
                  
                </div>,
            headerAlign: 'center', 
            flex: 1
        },
    ];
    
const changeOrder = async (row, direction) => {
  try {
    const currentRank = row.displayOrder;

    // Check boundaries
    if ((direction === 2 && currentRank === 1) ||
        (direction === 1 && currentRank === lastRank)) {
      return; // Cannot move
    }

    const newRank = direction === 2 ? currentRank - 1 : currentRank + 1;

    // Optimistically update local state
    setDataRows((prev) => {
      const items = prev.map((i) => ({ ...i }));

      const currentIndex = items.findIndex(i => i.id === row.id);
      const swapIndex = items.findIndex(i => i.displayOrder === newRank);

      if (currentIndex !== -1 && swapIndex !== -1) {
        // Swap the ranks
        items[currentIndex].displayOrder = newRank;
        items[swapIndex].displayOrder = currentRank;
      }

      // Sort by displayOrder for rendering
      return items.sort((a, b) => a.displayOrder - b.displayOrder);
    });

    // Call API to update backend
    await axios.put(
      `${apiAddress}/api/SubSection/updaterankloyalty`,
      null,
      {
        params: {
          id: row.id,
          status: direction
        }
      }
    );

    toast.success("Display order updated", { position: "top-right", autoClose: 2000 });

  } catch (error) {
    console.error("Change order error:", error);
    toast.error("Failed to update display order", { position: "top-right", autoClose: 3000 });

    // Rollback UI in case of error
    loadLoyaltyData(selectedRes);
  }
};




const changeOrderByTextBox = async (event, row) => {
  const inputValue = Number(event.target.value);

  // Invalid input
  if (isNaN(inputValue)) {
    toast.error("Please enter a valid number");
    return;
  }

  // Same rank, no need to call API
  if (inputValue === row.displayOrder) return;

  // Out of range
  if (inputValue < 1 || inputValue > lastRank) {
    toast.error(`Display order must be between 1 and ${lastRank}`);
    return;
  }

  const oldRank = row.displayOrder;
  const newRank = inputValue;

  // ✅ Optimistically update state immediately
  setDataRows((prev) => {
    const items = prev.map((i) => ({ ...i }));
    const idx = items.findIndex(i => i.id === row.id);
    if (idx === -1) return prev;

    // Shift other items between old and new rank
    if (newRank < oldRank) {
      items.forEach(it => {
        if (it.displayOrder >= newRank && it.displayOrder < oldRank) {
          it.displayOrder += 1;
        }
      });
    } else if (newRank > oldRank) {
      items.forEach(it => {
        if (it.displayOrder <= newRank && it.displayOrder > oldRank) {
          it.displayOrder -= 1;
        }
      });
    }

    items[idx].displayOrder = newRank;
    return items.sort((a, b) => a.displayOrder - b.displayOrder);
  });

  // ✅ Call backend SP to persist change
  try {
    await axios.put(
      `${apiAddress}/api/SubSection/updaterankwithtextboxloyalty`,
      null,
      { params: { id: row.id, newRank } }
    );

    toast.success("Display order updated", {
      position: "top-right",
      autoClose: 2000,
    });
  } catch (error) {
    console.error("Textbox order change error:", error);
    toast.error("Failed to update display order");

    // Rollback: reload data from backend
    loadLoyaltyData(selectedRes);
  }
};




    const loadRestaurantData = async () => {
        const token = localStorage.getItem("gotasteadmintoken");
        var decodedData = {};
        if (token != null) {
            try {
                decodedData = jwt_decode(token);
            } catch (error) { }
        }
        const restaurant = JSON.parse(localStorage.getItem("restaurant"));
        
        axios.get(
            apiAddress + "/api/Restaurant/getrestaurantdetailsbyidfortable/" +
            decodedData.UserId + "/" + restaurant.id
        ).then((response) => {
            var list = [];
            response.data.map((dt, i) => {
                var obj = {
                    id: dt.id,
                    name: dt.name,
                    address: dt.addressLine1,
                    PhoneNumber: dt.phoneNumber,
                    Email: dt.emailAddress,
                    isActive: dt.isActive
                };
                list.push(obj);
            });

            setRestaurantDataRows(list);
            if (response.data.length > 0) {
                loadLoyaltyData(response.data[0])
                setselectedRes(response.data[0])
            }
        });
    };

  const loadLoyaltyData = (data) => {
    axios({
        method: 'get',
        url: apiAddress + '/api/SubSection/GetLoyalitySchemeByRestaurantId/' + data.id,
    })
    .then((response) => {
        console.log("Loyalty Data:", response.data);
        
        // Ensure response is always an array
        const dataArray = Array.isArray(response.data) ? response.data : [response.data];

        // ⬇️ Only take active loyalty data
        const activeData = dataArray.filter(dt => dt.isActive === true);

            const list = activeData.map(dt => ({
                id: dt.id,
                restaurantId: dt.restaurantId,
                isEnabled: dt.isEnabled,
                isCountIncreaseByOrder: dt.isCountIncreaseByOrder,
                orderAmount: dt.orderAmount,
                reward: dt.reward,
                displayOrder: dt.rank
            }));

            // set rows and update lastRank to the highest displayOrder
            setDataRows(list);
            const maxRank = list.reduce((max, item) => Math.max(max, item.displayOrder || 0), 0);
            setLastRank(maxRank);
        
    })
    .catch((error) => {
        console.error("Error loading loyalty data:", error);
        setDataRows([]);
       
        toast.error("Failed to load loyalty schemes", {
            position: "top-right",
            autoClose: 3000,
        });
    });
}


    const selectDataForEdit = (row) => {
        console.log("Selected for edit:", row);
        setselectedDatas(row.id)
    }

    const handleDeleteSingle = (row) => {
        setSelectedDatarows([row.id]);
        setopenConfirmaitonModal(true);
    }

    const handleAddItem = (AddSectionData) => {
        setOpenAddSection(AddSectionData)
        loadLoyaltyData(selectedRes);
    }

    const handleUpdateItem = (AddItemData) => {
        setOpen(AddItemData);
        loadLoyaltyData(selectedRes);
    }

   const handleClickOpen = () => {
    setOpenAddSection(true);
    setDialogType('Add Loyalty Scheme');
}

    const handleAddMenuDialogData = (data) => {
        setSelectedData(data);
    }

    const getselectedData = (props) => {
        console.log("Selected rows:", props)
        setSelectedDatarows(props)
    }

 const deleteBin = async () => {
    if (!selectedDataRows || selectedDataRows.length === 0) {
        errorToast("Please select at least one loyalty scheme");
        return;
    }

    try {
        await axios.put(`${apiAddress}/api/SubSection/DeleteloyaltyScheme`, selectedDataRows);

        toast.success("Loyalty scheme(s) deleted successfully!", {
            position: "top-right",
            autoClose: 3000,
            theme: "colored",
        });

        setopenConfirmaitonModal(false);
        setSelectedDatarows([]);
        loadLoyaltyData(selectedRes);
    } catch (error) {
        toast.error("Failed to delete loyalty scheme(s)", {
            position: "top-right",
            autoClose: 3000,
            theme: "colored",
        });
        setopenConfirmaitonModal(false);
    }
};

    const errorToast = (msg) => {
        toast.error(msg, {
            position: "top-right",
            autoClose: 3000,
            theme: "colored",
        });
    }

    useEffect(() => {
        loadRestaurantData()
        console.log("Loyalty Scheme page loaded")
    }, [])

    const handleNext = (swiperRef) => {
        swiperRef.current.swiper.slideNext();
    };

    const handlePrev = (swiperRef) => {
        swiperRef.current.swiper.slidePrev();
    };

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
      setValue(newValue);
    };

    const handleTabClick = (index) => {
        setActiveTab(index);
    };

    const onTabClick = (data) => {
        console.log("Selected restaurant:", data)
        setselectedRes(data);
        loadLoyaltyData(data)
    };

    const TabViewItem = ({ children, count, data }) => {
        return (
            <div onClick={() => { onTabClick(data); }}>
                {<div>{children}</div>}
            </div>
        );
    };

    return (
        <div>
  <div>
     {restaurantDataRows.length > 0 ? (
                    <div className="tabview">
                        <TabContext value={value}>
                            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                                <div className="slider-container">
                                    <button
                                        onClick={() => { handlePrev(sliderRef); }}
                                        className="arrow-btn-food"
                                    >
                                        <img src={LeftArrow} alt={"arrow"} />
                                    </button>
                                    <Swiper
                                        spaceBetween={10}
                                        slidesPerView={"auto"}
                                        ref={sliderRef}
                                    >
                                        <TabList
                                            onChange={handleChange}
                                            aria-label="restaurant tabs"
                                            variant="scrollable"
                                            scrollButtons="auto"
                                        >
                                            {restaurantDataRows.map((dt, i) => {
                                                return (
                                                    <SwiperSlide
                                                        key={i}
                                                        style={{ width: "auto" }}
                                                        className={i === activeTab ? "tab-active" : ""}
                                                    >
                                                        <Tab
                                                            className="p-0"
                                                            label={
                                                                <TabViewItem count={i} data={dt}>
                                                                    <div style={{ padding: '13px' }}>
                                                                        {dt.name}
                                                                    </div>
                                                                </TabViewItem>
                                                            }
                                                          value={`${i}`}
                                                            onClick={() => handleTabClick(i)}
                                                        />
                                                    </SwiperSlide>
                                                );
                                            })}
                                        </TabList>
                                    </Swiper>
                                    <button
                                        onClick={() => { handleNext(sliderRef); }}
                                        className="arrow-btn-food"
                                    >
                                        <img src={RightArrow} alt="arrow" />
                                    </button>
                                </div>
                            </Box>

                            {restaurantDataRows.map((dt, i) => {
                              return value === `${i}` ? (
                                    <div key={i}>
                                        <Grid
                                            container
                                            alignItems="center"
                                            justifyContent="space-between"
                                            mt={2}
                                            mb={2}
                                            style={{ width: '100%' }}
                                        >
                                            <SweetAlertModal
                                                headerText={"Are you sure?"}
                                                bodyText={"You want to delete this loyalty scheme?"}
                                                open={openConfirmaitonModal} 
                                                onyes={deleteBin}
                                                close={() => { setopenConfirmaitonModal(false) }}
                                            />

                                            <Grid item>
                                                <Grid container spacing={2} alignItems="center">
                                                    <Grid item>
<Tooltip title="Add Loyalty Scheme" arrow>
  <Button
    color="primary"
    size="medium"
    variant="contained"
    style={{ 
      borderRadius: '50%', 
      minWidth: 'auto'
    }}
    onClick={handleClickOpen}
  >
    +
  </Button>
</Tooltip>

                                                    </Grid>
                                                    <Grid item>
                                                        <div className='roundedCorner'>
                                                        <Tooltip title="Delete" arrow>
  <img
    src={bin}
    alt="delete"
    style={{ width: '1rem', cursor: 'pointer' }}
    onClick={() => {
      selectedDataRows.length === 0
        ? errorToast("Please select a row")
        : setopenConfirmaitonModal(true)
    }}
  />
</Tooltip>

                                                        </div>
                                                    </Grid>
                                                    <Grid>
<Tooltip title="Settings" arrow>
  <Settings
    style={{ 
      width: '2.2rem',
      height: '2.2rem',
      backgroundColor: '#f0f0f0',
      padding: '5px',
      borderRadius: '8px',
      cursor: 'pointer',
      marginLeft: '14px',
      marginTop: '14px'
    }}
    onClick={() => setOpenSettingsModal(true)}
  />
</Tooltip>

<LoyaltySettingsModal
  open={openSettingsModal}
  onClose={() => setOpenSettingsModal(false)}
  selectedRestaurant={selectedRes}
/>


                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Paper>
                                            {dataRows.length > 0 ? (
                                                <CustomDataGrid
                                                    columns={columns}
                                                    dataRows={dataRows}
                                                    getselectedData={getselectedData}
                                                />
                                            ) : (
                                                <div style={{ padding: '20px', textAlign: 'center' }}>
                                                    <p>No Loyalty Scheme Found</p>
                                                    <p style={{ fontSize: '12px', color: '#666' }}>
                                                        Click the + button to add a loyalty scheme for this restaurant
                                                    </p>
                                                </div>
                                            )}
                                        </Paper>
                                    </div>
                                ) : null;
                            })}
                        </TabContext>
                    </div>
                ) : (
                    <div className="mt-1">
                        <p>No Restaurant Found</p>
                    </div>
                )}

                <AddLoyaltyDialog 
                    open={openAddSection}
                    dialogType={dialogType}
                    onHandleAddItem={handleAddItem}
                    onHandleSelectedData={handleAddMenuDialogData}
                    selectedRestaurant={selectedRes}
                />
            </div>
            
            {open && (
                <UpdateLoyaltyDialog 
                    open={open}
                    onHandleAddItem={handleUpdateItem}
                    selectedId={selectedDatas} 
                    selectedRestaurant={selectedRes}
                />
            )}
        </div>
    );
}

export default LoyaltyScheme;